// https://www.30secondsofcode.org/js/s/pick
export const pick = (obj: any, arr: any[]) =>
  arr.reduce((acc: any, curr: any) => {
    if (curr in obj) {
      acc[curr] = obj[curr];
    }
    return acc;
  }, {});
